<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [label]="label"
  [areaName]="areaName"
  [model]="model"
  [columns]="headerColumns"
  [isShowModal]="false"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="content-grid row">
      <div class="content-grid_right col-4">
        {{ "ClientApp.FrontOffice.Inv.SaleFormula.ProductAnalysis" | translate }}
        <editable-grid
          #grid
          [isAdd]="true"
          [columns]="headersColumns"
          [dataList]="formulas"
          (valueChanges)="onHeaderChanges($event)"
          (afterDeleted)="showHideActions()">
        </editable-grid>
      </div>
      <div class="content-grid_left col-8">
        {{ "ClientApp.FrontOffice.Inv.SaleFormula.ProductComponents" | translate }}
        <editable-grid
          [isAdd]="addGoods"
          [columns]="detailsColumns"
          [dataList]="selectedRow?.SaleFormulaDetails"
          (onLookupChanges)="onLookupChanges($event)"
          (formGroupValueChanges)="onDetailRowChanges($event)">
        </editable-grid>
      </div>
    </div>
    <ssg-button
      class="open-goods"
      (click)="openGoodsForm()"
      [tooltip]="'ClientApp.FrontOffice.Inv.SaleFormula.AddWarehouseItem' | translate"
      icon="icon-post_add-o"
      [label]="'ClientApp.FrontOffice.Inv.SaleFormula.AddWarehouseItem' | translate"></ssg-button>
  </ng-container>
</dynamic-form>
